// extracted by mini-css-extract-plugin
export var advancedBtn = "ArboretumSearchResults-module--advancedBtn--907ff";
export var advancedBtnWrap = "ArboretumSearchResults-module--advancedBtnWrap--d750f";
export var arboretumsearchresults = "ArboretumSearchResults-module--arboretumsearchresults--58712";
export var caret = "ArboretumSearchResults-module--caret--cf948";
export var filterContainer = "ArboretumSearchResults-module--filterContainer--bab87";
export var filtersHeader = "ArboretumSearchResults-module--filtersHeader--1ccb1";
export var label = "ArboretumSearchResults-module--label--bd2b3";
export var open = "ArboretumSearchResults-module--open--c27df";
export var panel = "ArboretumSearchResults-module--panel--0f9c3";
export var panelButton = "ArboretumSearchResults-module--panelButton--274b0";
export var refinements = "ArboretumSearchResults-module--refinements--eea42";
export var results = "ArboretumSearchResults-module--results--8bc6b";
export var resultsContainer = "ArboretumSearchResults-module--resultsContainer--ea75e";
export var resultsInfo = "ArboretumSearchResults-module--resultsInfo--7a299";
export var text = "ArboretumSearchResults-module--text--60e07";
export var tooltip = "ArboretumSearchResults-module--tooltip--45451";
export var tooltipText = "ArboretumSearchResults-module--tooltipText--297eb";
export var totalHits = "ArboretumSearchResults-module--totalHits--5994c";